<template>
    <div class="profile">
        <ProfileUser v-if="$vuetify.breakpoint.xsOnly" />
        <LabeledCard v-if="$vuetify.breakpoint.smAndUp" :label="$t('Профиль')" class="pt-10">
            <ProfileUser />
        </LabeledCard>
    </div>
</template>

<script>
import ProfileUser from '@/components/administration/ProfileUser.vue';
import LabeledCard from '@/components/ui/LabeledCard';

export default {
    name: 'Profile',
    components: {
        ProfileUser,
        LabeledCard
    }
};
</script>
